import Content from '@common/content';
import Footer from '@common/footer';
import Header from '@common/header';
import Layout from '@common/layout';
import { PassInterviewCustomHead } from '@components/common/customHead';
import { useInterviewHistoryList } from '@repository/interviewPractices/useInterviewPractices';
import { useState } from 'react';
import InterviewPracticeQuestionSelectHeader from '../common/header/header';
import { HistoryDetailModal } from './detail';
import InterviewPracticeHistoryList from './list';

const InterviewHistory = () => {
  const { data: historyListData } = useInterviewHistoryList();

  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [selectedQuestionSn, setSelectedQuestionSn] = useState(-1);
  const handleCloseModal = () => setDetailModalVisible(false);
  const handleOpenModal = (sn: number) => {
    setDetailModalVisible(true);
    setSelectedQuestionSn(sn);
  };

  if (!historyListData) return null;

  return (
    <Layout>
      <PassInterviewCustomHead />
      <Header />
      <Content>
        <InterviewPracticeQuestionSelectHeader />
        {selectedQuestionSn !== -1 && (
          <HistoryDetailModal
            visible={detailModalVisible}
            onClickBg={handleCloseModal}
            onClose={handleCloseModal}
            questionSn={selectedQuestionSn}
          />
        )}
        <InterviewPracticeHistoryList openModal={handleOpenModal} historyListData={historyListData} />
      </Content>
      <Footer />
    </Layout>
  );
};
export default InterviewHistory;
